<template>
    <v-tab-item class="fill-height">
        <v-layout column align-center justify-center class="h-100 text-center">
            <h3 class="tit mb-8 mb-lg-16">미팅생성이 완료되었습니다.</h3>
            <p class="page-text--lg grey-6--text mb-8 mb-lg-16">
                해당 URL을 담당 지원자와 공유하여 미팅일정을 잡아주세요. <br />
                해당 URL을 빠르게 공유하려면 문자서비스를 이용해보세요.
            </p>
            <v-btn rounded large color="grey-f1" class="primary--text" @click="copy(matchUrl)"> {{ matchUrl }} </v-btn>
            <div class="v-btn-group">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="$emit('exit')">
                    <span class="grey-6--text">나가기</span>
                </v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="$emit('next')">
                    <span>문자로 정보 발송</span>
                </v-btn>
            </div>
        </v-layout>

        <!-- <v-layout column align-center justify-center fill-height style="overflow-y: hidden">
            <v-card-title class="font-size-26 font-size-md-30 font-size-lg-36">미팅생성이 완료되었습니다.</v-card-title>
            <v-card-subtitle class="page-text--lg pt-16 grey-6--text">
                해당 URL을 담당 지원자와 공유하여 미팅일정을 잡아주세요. <br />
                해당 URL을 빠르게 공유하려면 문자서비스를 이용해보세요.
            </v-card-subtitle>
            <v-card-text class="text-center pa-0">
                <v-btn rounded class="rounded-xl mx-auto  mb-20 mb-md-40 primary--text" color="grey lighten-3" @click="copy(matchUrl)"> {{ matchUrl }} </v-btn>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn outlined @click="$emit('exit')"> 나가기</v-btn>
                <v-btn color="primary"> 문자로 정보 발송 </v-btn>
            </v-card-actions>
        </v-layout> -->
    </v-tab-item>
</template>

<script>
import { initMeeting } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initMeeting }, // meeting
    },
    computed: {
        matchUrl() {
            return `${window.location.origin}/meetings/${this.value?._id}`;
        },
    },
    methods: {
        copy(string) {
            navigator.clipboard.writeText(string);
            alert("주소가 복사되었습니다");
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--large {
        font-weight: 400;
    }
    @media (min-width: 1024px) {
        .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--large {
            height: 60px;
            padding: 0 24px;
            font-size: 2rem;
        }
    }
}
</style>
